module.exports = __webpack_public_path__ + "static/img/5.9b42b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/5.png
// module id = IBTm
// module chunks = 0